import delay from 'delay';

/**
 *
 * 通过script标签加载js资源
 * @param url 资源地址
 * @param timeout 加载超时限制，单位为毫秒
 */
export default async function loadScript(url, timeout = 30 * 1000) {
    // eslint-disable-next-line
    let script;
    const promise = new Promise((resolve, reject) => {
        script = document.createElement('script');
        script.onload = () => resolve(true);
        script.onerror = err => reject(err);

        script.type = 'text/javascript';
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    });

    try {
        await Promise.race([
            promise,
            delay.reject(timeout, {value: new Error('请求超时')})
        ]);
    }
    catch (err) {
        removeScript(script);
        throw err;
    }

    removeScript(script);
}

function removeScript(script) {
    script.onload = null;
    script.onerror = null;
    if (script.parentNode) {
        script.parentNode.removeChild(script);
    }
}

export const loadScriptCallback = (url, userId, appId) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    // chrome,opera,firefox,safari
    script.onload = function () {
        renderProfile(userId, appId);
    };
    // IE
    script.onreadystatechange = function () {
        if (this.readyState === 'complete' || this.readyState === 'loaded') {
            renderProfile(userId, appId);
        }
    };
    script.src = url;
    document.head.appendChild(script);
};

function renderProfile(userId, appId) {
    if (window._uccc == null) {
        return;
    }
    window._uccc.renderProfile({
        container: document.getElementById('header-username'),
        userID: userId,
        appID: appId,
        env: 'offline',
        profile: {
            overlayClassName: 'uccc-profile-overlay',
            children: []
        }
    });
}